import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { constants } from "../constants";
import { Event } from "../models/event.model";

@Injectable({ providedIn: 'root' })
export class EventService {

    private static readonly EVENT_URL = `${constants.BASE_URL}/events`;

    constructor(private http: HttpClient) { }

    getEvents(cpaId: string): Observable<Event[]> {
        return this.http.get<Event[]>(`${EventService.EVENT_URL}/${cpaId}`)
            .pipe(map((response: any[]) => response.map(event => new Event(event))));
    }

}